<template>
  <section class="profile-page">
    <div class="profile-hero">
      <div class="profile-avatar" aria-hidden="true">
        <img
          v-if="picture"
          :src="`https://graph.facebook.com/${picture}/picture?type=large`"
          alt=""
          @load="imgLoaded = true"
          :class="{ loaded: imgLoaded }"
        >
        <span v-else class="profile-initials">{{ initials }}</span>
      </div>
      <div class="profile-identity">
        <p class="profile-kicker">Minha conta</p>
        <h1 class="profile-name">{{ name || 'Membro Swiss' }}</h1>
        <p class="profile-email">{{ email }}</p>
      </div>
    </div>

    <!--<nav class="profile-tabs" aria-label="Secoes do perfil">
      <button
        type="button"
        class="profile-tab"
        :class="{ active: stage === 'dados' }"
        @click="stage = 'dados'"
      >
        <i class="fas fa-user"></i>
        Meus dados
      </button>
      <button
        v-if="!picture"
        type="button"
        class="profile-tab"
        :class="{ active: stage === 'senha' }"
        @click="stage = 'senha'"
      >
        <i class="fas fa-key"></i>
        Alterar senha
      </button>
    </nav>-->

    <div class="profile-card">
      <transition name="page" mode="out-in">
        <!-- Dados -->
        <div v-if="stage === 'dados'" key="dados" class="profile-panel">
          <form @submit.prevent class="form profile-form">
            <div class="form-section">
              <h2 class="form-section-title">Dados pessoais</h2>
              <div class="form-grid">
                <div class="form-field form-field--full">
                  <label>Nome</label>
                  <input
                    v-model="name"
                    type="text"
                    placeholder="Seu nome completo"
                    :class="{ error: error.indexOf('name') > -1 }"
                    style="text-transform: uppercase"
                  >
                  <div v-if="error.indexOf('name') > -1" class="hint">Nome invalido. Informe nome e sobrenome.</div>
                </div>
                <div class="form-field">
                  <label>E-mail</label>
                  <input v-model="email" :disabled="true" type="email" placeholder="Seu e-mail">
                </div>
                <div class="form-field">
                  <label>CPF</label>
                  <input v-model="document" :disabled="true" type="text" :class="{ error: error.includes('document') }">
                  <div v-if="error.indexOf('document') > -1" class="hint">CPF obrigatorio.</div>
                </div>
                <div class="form-field form-field--full">
                  <label>Celular</label>
                  <input
                    v-model="phone"
                    type="text"
                    placeholder="Numero do celular"
                    :class="{ error: error.indexOf('phone') > -1 }"
                  >
                  <div v-if="error.indexOf('phone') > -1" class="hint">Numero de celular invalido.</div>
                </div>
              </div>
            </div>

            <div class="form-section">
              <h2 class="form-section-title">Plataformas</h2>
              <p class="form-section-desc">Usado para liberar indicadores e acesso ao grupo de assinantes.</p>
              <div class="form-grid">
                <div class="form-field">
                  <label>Telegram</label>
                  <input v-model="telegram" type="text" placeholder="@usuario" style="text-transform: lowercase;">
                </div>
                <div class="form-field">
                  <label>TradingView</label>
                  <input v-model="traddingview" type="text" placeholder="Usuario TradingView" style="text-transform: lowercase;">
                </div>
              </div>
            </div>

            <div class="form-section">
              <h2 class="form-section-title">Como nos conheceu</h2>
              <div class="form-field form-field--full">
                <label>Chegou ate o Swiss Money atraves de</label>
                <select v-model="fonte" :disabled="hasfonte">
                  <option value="NENHUM">Nenhum</option>
                  <option value="TERCIO">Trader de Mesa Proprietaria</option>
                  <option value="REGIS">Pra cima Traders</option>
                  <option value="ANDERSON">Mesa Prop Americana / Trader Funding</option>
                  <option value="SWISS">Swiss Money Global</option>
                  <option value="OUTRO">Outro</option>
                </select>
              </div>
              <div v-if="fonte === 'OUTRO'" class="form-field form-field--full">
                <label>Informe a origem</label>
                <input v-model="newfonte" type="text" placeholder="De onde veio?" style="text-transform: uppercase;">
              </div>
            </div>

            <div class="form-section form-section--footer">
              <h2 class="form-section-title">Preferencias</h2>
              <label class="preference-card">
                <input v-model="newsletter" type="checkbox" class="preference-input">
                <span class="preference-toggle" aria-hidden="true">
                  <span class="preference-toggle-thumb"></span>
                </span>
                <span class="preference-text">
                  <span class="preference-title">Quero receber novidades da Swiss Money</span>
                  <span class="preference-desc">Lancamentos, lives e conteudos educacionais no seu e-mail.</span>
                </span>
              </label>
              <button type="button" @click="changeDetails" class="button-save button-save--block">
                <i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i>
                <span>Salvar alteracoes</span>
              </button>
            </div>
          </form>
        </div>

        <!-- Senha -->
        <div v-else-if="stage === 'senha'" key="senha" class="profile-panel">
          <form @submit.prevent class="form profile-form">
            <div class="form-section">
              <h2 class="form-section-title">Nova senha</h2>
              <p class="form-section-desc">Use pelo menos 6 caracteres. Evite senhas que voce ja utiliza em outros sites.</p>
              <div class="form-grid">
                <div class="form-field form-field--full">
                  <label>Nova senha</label>
                  <input
                    v-model="password1"
                    type="password"
                    placeholder="Minimo 6 caracteres"
                    :class="{ error: error.indexOf('password1') > -1 }"
                  >
                  <div v-if="error.indexOf('password1') > -1" class="hint">Senha invalida.</div>
                </div>
                <div class="form-field form-field--full">
                  <label>Confirmar senha</label>
                  <input
                    v-model="password2"
                    type="password"
                    placeholder="Repita a senha"
                    :class="{ error: error.indexOf('password2') > -1 }"
                  >
                  <div v-if="error.indexOf('password2') > -1" class="hint">As senhas nao coincidem.</div>
                </div>
              </div>
            </div>
            <div class="form-section form-section--footer">
              <button type="button" @click="changePassword" class="button-save button-save--block">
                <i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i>
                <span>Atualizar senha</span>
              </button>
            </div>
          </form>
        </div>

        <!-- Fluxos LGPD legados (mantidos para compatibilidade) -->
        <div v-else-if="stage === 'remove'" key="remove" class="profile-panel profile-panel--legal">
          <form @submit.prevent class="form profile-form">
            <p>Aqui voce pode exercer seus direitos previstos na LGPD e solicitar a exclusao de seus dados pessoais.</p>
            <label class="switch switch--legal">
              <input v-model="removeConfirm" type="checkbox">
              <span class="slider"></span>
              <span class="text">Sim, estou ciente e quero excluir meus dados pessoais.</span>
            </label>
            <div @click="removeNextStep" class="button-link">Prosseguir com a exclusao</div>
            <button @click="stage = 'dados'" type="button" class="button-ghost">Cancelar</button>
          </form>
        </div>
        <div v-else-if="stage === 'remove-online'" key="remove-online" class="profile-panel profile-panel--legal">
          <form @submit.prevent class="form profile-form">
            <p>Voce possui acesso a eventos online vigentes. Ao excluir sua conta, perdera esse acesso definitivamente.</p>
            <p v-for="show in onlineShows" :key="show.id">
              <strong>{{ show.name }}</strong><br>
              {{ show.live ? 'Dia ' : 'Valido ate ' }}
              {{ String(show.date).split(' ')[0] + ' as ' + String(show.date).split(' ')[1].split(':')[0] + ':' + String(show.date).split(' ')[1].split(':')[1] }}
            </p>
            <label class="switch switch--legal">
              <input v-model="removeOnlineConfirm" type="checkbox">
              <span class="slider"></span>
              <span class="text">Estou ciente que perderei o acesso aos eventos acima.</span>
            </label>
            <div @click="removeOnlineNextStep" class="button-link">Prosseguir</div>
            <button @click="stage = 'dados'" type="button" class="button-ghost">Cancelar</button>
          </form>
        </div>
        <div v-else-if="stage === 'remove-tickets'" key="remove-tickets" class="profile-panel profile-panel--legal">
          <form @submit.prevent class="form profile-form">
            <p>Faca o backup dos seus ingressos antes de excluir a conta.</p>
            <button @click="removeSendTickets" type="button" class="button-save">
              <i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-paper-plane'"></i>
              <span>Enviar ingressos por e-mail</span>
            </button>
            <div @click="stage = 'remove-confirm'" class="button-link">Prosseguir com exclusao</div>
            <button @click="stage = 'dados'" type="button" class="button-ghost">Cancelar</button>
          </form>
        </div>
        <div v-else-if="stage === 'remove-confirm'" key="remove-confirm" class="profile-panel profile-panel--legal">
          <form @submit.prevent class="form profile-form">
            <p>Confirme a exclusao dos dados vinculados a <strong>{{ email }}</strong>.</p>
            <div @click="callRemove" class="button-link button-link--danger">Confirmar exclusao</div>
            <button @click="stage = 'dados'" type="button" class="button-ghost">
              <i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-times'"></i>
              <span>Cancelar</span>
            </button>
          </form>
        </div>
      </transition>
    </div>

    <!--<div class="profile-shortcuts">
      <router-link to="/assinatura" class="shortcut-card">
        <i class="fas fa-handshake"></i>
        <span>Minhas assinaturas</span>
        <i class="fas fa-chevron-right shortcut-arrow"></i>
      </router-link>
      <router-link to="/educacional" class="shortcut-card">
        <i class="fas fa-graduation-cap"></i>
        <span>Area educacional</span>
        <i class="fas fa-chevron-right shortcut-arrow"></i>
      </router-link>
    </div>-->
  </section>
</template>

<script>
import logger from '../../logger'
import { update, changePass } from '../api/customer'
import { removeData } from '../api/auth'
import { removeToken } from '../../util'
import { getByShowDate } from '../api/ticket'
import { send } from '../api/mail'

export default {
  name: 'userDetail',
  props: ['change', 'customer', 'previousShows', 'nextShows', 'onlineShows'],
  data () {
    return {
      stage: this.change || 'dados',
      loading: false,
      error: [],
      name: null,
      email: null,
      document: null,
      phone: null,
      newsletter: false,
      traddingview: null,
      telegram: null,
      password1: null,
      password2: null,
      picture: null,
      imgLoaded: false,
      removeConfirm: false,
      removeOnlineConfirm: false,
      hasfonte: false,
      newfonte: null,
      fonte: ''
    }
  },
  computed: {
    initials () {
      if (!this.name) return '?'
      const parts = String(this.name).trim().split(/\s+/).filter(Boolean)
      if (parts.length === 1) return parts[0].charAt(0).toUpperCase()
      return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase()
    }
  },
  mounted () {
    document.body.style.backgroundColor = '#0b0e11'
    this.name = this.customer.name
    this.email = this.customer.login
    this.document = this.customer.document
    this.phone = this.customer.phone
    this.newsletter = this.customer.newsletter
    this.picture = this.customer.picture
    this.telegram = this.customer.telegram
    this.traddingview = this.customer.traddingview
    this.fonte = this.customer.fonte
    this.hasfonte = !!this.fonte
  },
  methods: {
    async removeSendTickets () {
      try {
        this.loading = true
        for (const show of this.nextShows) {
          const tickets = await getByShowDate(show.id)
          send(this.customer.login, tickets.map(x => x.id))
        }
        this.$message.success('Ingressos enviados com sucesso', { duration: 3000 })
      } catch (error) {
        logger.error(error, this)
      } finally {
        this.loading = false
      }
    },
    removeOnlineNextStep () {
      if (this.removeOnlineConfirm) {
        if (this.nextShows.length > 0) this.stage = 'remove-tickets'
        else this.stage = 'remove-confirm'
        this.removeOnlineConfirm = false
      }
    },
    removeNextStep () {
      if (this.removeConfirm) {
        if (this.onlineShows.length > 0) this.stage = 'remove-online'
        else if (this.nextShows.length > 0) this.stage = 'remove-tickets'
        else this.stage = 'remove-confirm'
        this.removeConfirm = false
        this.removeOnlineConfirm = false
      }
    },
    async callRemove () {
      this.error = []
      try {
        this.loading = true
        await removeData()
        this.loading = false
        removeToken()
        this.$store.commit('user', null)
        this.$router.push('/')
        this.$message.success('Seus dados pessoais foram excluidos', { duration: 3000 })
      } catch (error) {
        this.loading = false
        const data = error.response ? error.response.data : {}
        if (data.error === 'Validation error') {
          this.error = data.fields
        } else {
          logger.error(error, this)
        }
      }
    },
    async changePassword () {
      if (this.loading) return false
      this.loading = true
      try {
        this.error = []
        await changePass(this.password1, this.password2)
        this.$router.push('/usuario')
        this.$message.success('Senha alterada com sucesso.', { duration: 3000 })
      } catch (error) {
        const data = error.response ? error.response.data : {}
        if (data.error === 'Validation error') {
          this.error = data.fields
        } else if (data.error === 'Different password') {
          this.error = ['password2']
        } else {
          logger.error(error, this)
        }
      }
      this.loading = false
    },
    async changeDetails () {
      if (this.loading) return false
      this.loading = true
      try {
        this.error = []
        if (this.newfonte) {
          this.fonte = String(this.newfonte).toUpperCase()
          this.hasfonte = true
        }
        await update(this.name, this.email, this.phone, this.newsletter, this.telegram, this.traddingview, this.fonte)
        this.$router.push('/usuario')
        this.$message.success('Alteracao realizada com sucesso.', { duration: 3000 })
      } catch (error) {
        const data = error.response ? error.response.data : {}
        if (data.error === 'Validation error') {
          this.error = data.fields
        } else {
          logger.error(error, this)
        }
      }
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.profile-page {
  max-width: 720px;
  margin: 0 auto;
  padding: 24px 16px 48px;
}

.profile-hero {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 24px;
  margin-bottom: 20px;
  border-radius: $lp-radius-lg;
  border: 1px solid $lp-border;
  background:
    radial-gradient(ellipse 80% 120% at 100% 0%, rgba($lp-accent, 0.08), transparent),
    $lp-panel;
}

.profile-avatar {
  flex-shrink: 0;
  width: 72px;
  height: 72px;
  border-radius: 50%;
  border: 2px solid rgba($lp-accent, 0.45);
  background: $lp-panel-2;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0;
    transform: scale(0.9);
    transition: opacity 0.3s, transform 0.3s;

    &.loaded {
      opacity: 1;
      transform: scale(1);
    }
  }
}

.profile-initials {
  font-size: 1.5rem;
  font-weight: 700;
  color: $lp-gold;
  letter-spacing: 0.04em;
}

.profile-kicker {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: $lp-gold;
  margin: 0 0 6px;
}

.profile-name {
  font-size: clamp(1.25rem, 3vw, 1.6rem);
  font-weight: 700;
  color: $lp-text;
  margin: 0 0 4px;
  line-height: 1.2;
}

.profile-email {
  font-size: 0.9rem;
  color: $lp-text-2;
  margin: 0;
  word-break: break-all;
}

.profile-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
}

.profile-tab {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 999px;
  border: 1px solid $lp-border;
  background: $lp-panel;
  color: $lp-text-2;
  font-size: 0.9rem;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s, background 0.2s;

  i {
    font-size: 0.85rem;
  }

  &:hover {
    border-color: $lp-border-strong;
    color: $lp-text;
  }

  &.active {
    border-color: rgba($lp-accent, 0.4);
    background: rgba($lp-accent, 0.1);
    color: $lp-gold;
  }
}

.profile-card {
  border-radius: $lp-radius-lg;
  border: 1px solid $lp-border;
  background: $lp-panel;
  overflow: hidden;
}

.profile-panel {
  padding: 8px 0 4px;
}

.profile-form {
  padding: 0;
}

.form-section {
  margin-bottom: 28px;
  padding-bottom: 24px;
  border-bottom: 1px solid $lp-border;

  &:last-of-type {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }

  &--inline {
    border-bottom: none;
    padding-bottom: 0;
    margin-bottom: 20px;
  }

  &--footer {
    border-bottom: none;
    margin-bottom: 0;
    padding-top: 8px;
    padding-bottom: 4px;
  }
}

.form-section-title {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: $lp-gold;
  margin: 0 0 14px;
}

.form-section-desc {
  font-size: 0.85rem;
  color: $lp-text-2;
  margin: -8px 0 14px;
  line-height: 1.45;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0 16px;

  @media (min-width: $desktop-width) {
    grid-template-columns: 1fr 1fr;
  }
}

.form-field {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin-bottom: 16px;

  &--full {
    grid-column: 1 / -1;
  }

  label {
    display: block;
    order: 1;
    margin-top: 0;
    margin-bottom: 6px;
    line-height: 1.3;
  }

  input,
  select,
  textarea {
    order: 2;
    width: 100%;
    box-sizing: border-box;
    margin-top: 0;
  }

  .hint {
    order: 3;
    margin-top: 4px;
  }
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 8px;
  margin-top: 8px;
}

.preference-card {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 16px;
  margin-bottom: 20px;
  border-radius: $lp-radius;
  border: 1px solid $lp-border;
  background: $lp-bg;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;

  &:hover {
    border-color: $lp-border-strong;
    background: $lp-panel-2;
  }
}

.preference-input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  pointer-events: none;
}

.preference-toggle {
  flex-shrink: 0;
  position: relative;
  width: 44px;
  height: 24px;
  margin-top: 2px;
  border-radius: 999px;
  background: $lp-panel-2;
  border: 1px solid $lp-border-strong;
  transition: background 0.25s, border-color 0.25s;
}

.preference-toggle-thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: $lp-text;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.35);
  transition: transform 0.25s, background 0.25s;
}

.preference-input:checked + .preference-toggle {
  background: rgba($lp-accent, 0.25);
  border-color: rgba($lp-accent, 0.55);

  .preference-toggle-thumb {
    transform: translateX(20px);
    background: $lp-accent-2;
  }
}

.preference-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.preference-title {
  font-size: 0.95rem;
  font-weight: 600;
  color: $lp-text;
  line-height: 1.35;
}

.preference-desc {
  font-size: 0.82rem;
  color: $lp-text-2;
  line-height: 1.45;
}

.button-save {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #fff;
  border: none;
  border-radius: 999px;
  background: linear-gradient(135deg, $lp-accent, $lp-accent-2);
  font-size: 0.95rem;
  font-weight: 600;
  min-height: 42px;
  padding: 0 22px;
  cursor: pointer;
  box-shadow: 0 4px 20px rgba($lp-accent, 0.2);
  transition: transform 0.15s, box-shadow 0.15s;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 24px rgba($lp-accent, 0.28);
  }

  &:focus {
    outline: none;
  }

  &--block {
    width: 100%;
    justify-content: center;
    min-height: 46px;
  }
}

.button-ghost {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  padding: 10px 18px;
  border-radius: 999px;
  border: 1px solid $lp-border-strong;
  background: transparent;
  color: $lp-text-2;
  cursor: pointer;

  &:hover {
    border-color: $lp-text-3;
    color: $lp-text;
  }
}

.button-link {
  cursor: pointer;
  margin: 16px 0;
  text-align: left;
  color: $lp-brand;
  text-decoration: underline;
  font-size: 0.9rem;

  &--danger {
    color: $error-color;
  }
}

.profile-panel--legal {
  padding: 20px;

  p {
    color: $lp-text-2;
    line-height: 1.5;
    margin-bottom: 12px;
  }
}

.switch--legal .text {
  text-transform: none;
}

.profile-shortcuts {
  display: grid;
  gap: 10px;
  margin-top: 20px;
}

.shortcut-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 18px;
  border-radius: $lp-radius;
  border: 1px solid $lp-border;
  background: $lp-panel;
  color: $lp-text;
  text-decoration: none;
  transition: border-color 0.2s, background 0.2s;

  > i:first-child {
    width: 20px;
    text-align: center;
    color: $lp-gold;
  }

  span {
    flex: 1;
    font-weight: 500;
  }

  .shortcut-arrow {
    color: $lp-text-3;
    font-size: 0.75rem;
  }

  &:hover {
    border-color: rgba($lp-accent, 0.35);
    background: $lp-panel-2;
  }
}

// Form overrides dentro do painel
.profile-form.form {
  display: block;
  padding: 20px 20px 8px;

  label:not(.switch) {
    color: $lp-text-2;
    margin-top: 0;
  }

  input,
  select {
    display: block;
    width: 100%;
    box-sizing: border-box;
    background: $lp-bg;
    border-color: $lp-border;
    color: $lp-text;
    margin-top: 0;

    &::placeholder {
      color: $lp-text-3;
    }

    &:disabled {
      background: $lp-surface !important;
      color: $lp-text-3;
      opacity: 1;
    }

    &:focus {
      border-color: rgba($lp-accent, 0.45);
    }
  }
}

.page-enter-active,
.page-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}

.page-enter,
.page-leave-to {
  opacity: 0;
  transform: translateY(6px);
}

@media screen and (min-width: $desktop-width) {
  .profile-page {
    padding: 32px 24px 56px;
  }

  .profile-hero {
    padding: 28px 32px;
  }

  .profile-form.form {
    padding: 28px 28px 12px;
  }
}
</style>
